export function unknownToError(e: unknown): Error {
  if (typeof e === "object" && e instanceof Error) {
    return e;
  }
  return new Error(String(e));
}
